import morphism, { createSchema } from 'morphism';

const recognitionResponseSchema = createSchema(
  {
    code: 'code',
    contacts: 'contacts',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    deleted: 'deleted',
    experienceSettings: 'experienceSettings',
    numberOfContacts: 'numberOfContacts',
    id: 'id',
    link: 'link',
    meta: 'meta',
    name: 'name',
    paymentMethod: 'paymentMethod',
    acceptanceRates: 'acceptanceRates',
    approval: 'approval',
    merchantOrder: 'merchantOrder',
    products: source =>
      source.products.map?.(product => ({
        id: product.merchantProductId,
        merchantProductId: product.merchantProductId,
        images:
          product?.images?.map(image => ({
            default: image?.default,
            full: image?.full,
            thumb: image?.thumb,
            url: image?.url
          })) || undefined,
        source: product?.source || undefined,
        name: product?.name,
        brand: product?.brand,
        prices: product.prices,
        skus: product.skus.map(sku => ({
          code: sku.code,
          price: sku.price,
          priceBreakdown: sku.priceBreakdown,
          regularPrice: sku.regularPrice,
          meta: sku.meta
        })),
        meta: product?.meta
      })),
    settings: 'settings',
    addons: source => source.addons.map?.(addon => ({ type: addon.type, data: addon.data })),
    flowCode: 'flowCode',
    status: 'status',
    source: 'source',
    updatedAt: 'updatedAt'
  },
  { undefinedValues: { strip: true } }
);

export default {
  recognition: createSchema(recognitionResponseSchema, { undefinedValues: { strip: true } }),
  list: createSchema(
    {
      docs: source => morphism(recognitionResponseSchema, source.docs),
      pagination: {
        limit: 'limit',
        page: 'page',
        pages: 'totalPages',
        total: 'totalDocs'
      }
    },
    { undefinedValues: { strip: true } }
  )
};
